import React from "react";
import Header from "../../../components/HOC/Header/Header";
import ConsentBox from "../../../components/Consent/ConsentBox";
import globalStyle from "../../../styles/global.style.module.scss"

function StudentConsentPage() {
  return (    
    <div>
      <Header />
      <div className={globalStyle.container}>
        <ConsentBox boxFor = "Home"/>
      </div>
    </div>
  );
}

export default StudentConsentPage;

